<template>
  <div>
    Comments
  </div>
</template>

<script>
export default {
  name: 'Comments',
};
</script>

<style lang="scss" scoped></style>
